<template>
  <div class="income-cost-detail">
    <el-tabs type="card" :value="currentTabName" @tab-click="tabClickHandler">
      <!-- 基础数据 -->
      <el-tab-pane label="基础数据" name="EarningCostBasicTable">
        <EarningCostBasicTable :detail="basicData" :closefn="closePage"/>
      </el-tab-pane>
      <!-- 收入成本确认表 -->
      <el-tab-pane label="收入成本确认表" name="EarningCostCheckTable">
        <EarningCostCheckTable
          :detail="earningCostCheckTableData"
          :id="id"
          :approveStatus="approveStatus"
          @export-click="exportData"
          :closefn="closePage"
        />
      </el-tab-pane>
      <!-- 收入成本汇总表 -->
      <el-tab-pane label="收入成本汇总表" name="EarningCostGatherTable">
        <EarningCostGatherTable
          :detail="earningCostGatherTableData"
          :id="id"
          :approveStatus="approveStatus"
          @export-click="exportData"
          :closefn="closePage"
        />
      </el-tab-pane>
      <!-- 收支明细表 -->
      <el-tab-pane label="收支明细表" name="EarningCostDetailTable">
        <EarningCostDetailTable
          :detail="earningCostDetailTableData"
          :id="id"
          :approveStatus="approveStatus"
          @export-click="exportData"
          :closefn="closePage"
        />
      </el-tab-pane>
      <!-- 工程成本明细表 -->
      <el-tab-pane label="工程成本明细表" name="ProjectCostDetailTable">
        <ProjectCostDetailTable
          :detail="projectCostDetailTableData"
          :id="id"
          :approveStatus="approveStatus"
          @export-click="exportData"
          :closefn="closePage"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="fromApprove ? '审批信息' : '审批流程'"
        name="EarningCostApprovePane"
      >
        <!-- 审批操作 -->
        <div v-if="fromApprove" style="padding: 20px;height:calc(100vh - 140px);">
          <approveItem
              :itemId="id"
              :approveType="approveType"
              :subapproveType="subapproveType"
              @finishApprove="closePage"
            >
          </approveItem>
        </div>
        <!-- 审理流程 -->
        <div v-else style="padding: 20px;height:calc(100vh - 140px);width:90%;overflow:auto">
          <approveLine
              :itemId="id"
              :approveType="approveType"
            ></approveLine>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="year-month">
      <p style="margin-bottom: 0">记录日期：</p>
      <el-date-picker
        v-model="yearMonth"
        type="month"
        placeholder="请选择"
        @change="yearMonthChange"
      >
      </el-date-picker>
    </div>
  </div>
</template>

<script>
/**
 * 收入成本管理-查看收入记录
 */
import EarningCostBasicTable from "./EarningCostBasicTable";
import ProjectCostDetailTable from "./ProjectCostDetailTable";
import EarningCostDetailTable from "./EarningCostDetailTable";
import EarningCostGatherTable from "./EarningCostGatherTable";
import EarningCostCheckTable from "./EarningCostCheckTable";
import approveItem from "@/page/approveComponents/ApproveItem"; //历史审批流程
import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
import Constants, { formatQueryDate } from "../../utils/consts";
import {
  queryEarningCostCheckTable,
  queryEarningCostGatherTable,
  queryEarningCostDetailTable,
  queryProjectCostDetailTable,
  earningCost,
  earningCostExportapi,
} from "../../services/financeService";
import { goBackApprove } from "@/page/approveComponents/approve";

export default {
  data() {
    return {
      id: undefined,
      approveStatus: undefined,
      yearMonth: undefined,
      earningCostCheckTableData: {}, // 收入成本确认表
      earningCostGatherTableData: {}, // 收入成本汇总表
      earningCostDetailTableData: {}, // 收支明细表
      projectCostDetailTableData: {}, // 工程成本明细表
      basicData: {},
      currentTabName: "EarningCostBasicTable",
      fromApprove: false,
      approveFlag: "",
      approveType: "EARNING_COST", //审批类型
      subapproveType: "", // 审批子类型
      approveTableProps: [
        { prop: "approveUserName", label: "员工名称" },
        { prop: "jobName", label: "岗位名称" },
        { prop: "opinion", label: "相关意见" },
        { prop: "statusName", label: "当前状态" },
      ],
      approveFormData: {
        status: null,
        opinion: "",
        sort: null,
      },
      canApprove: false,
    };
  },
  components: {
    EarningCostCheckTable,
    EarningCostGatherTable,
    EarningCostDetailTable,
    ProjectCostDetailTable,
    EarningCostBasicTable,
    approveItem,
    approveLine,
  },

  methods: {
    onActive() {
      let params = this.tabRouteParam || {};
      console.log("传进来的参数", params);
      this.id = params.id;
      this.approveStatus = params.approveStatus;
      this.approveFlag = params.approveFlag;
      if (params.approveFlag == "currentApprove") {
        // 从待审批列表来
        this.fromApprove = true;
      } else {
        this.fromApprove = false;
      }
      // 每个tab对应的数据都是通过专门的接口返回的
      // 默认展示基本数据，这里去获取一次
      this.getBasicData();
    },

    tabClickHandler(tab) {
      this.currentTabName = tab.name;
      switch (tab.name) {
        case "EarningCostBasicTable":
          this.getBasicData(); // 基础表数据
          break;
        case "EarningCostCheckTable": // 收入成本确认表
          this.getQueryEarningCostCheckTable();
          break;
        case "EarningCostGatherTable":
          this.getEarningCostGatherTable(); // 收入成本汇总表
          break;
        case "EarningCostDetailTable":
          this.getEarningCostDetailTable(); // 收支明细表
          break;
        case "ProjectCostDetailTable":
          this.getProjectCostDetailTable(); // 工程成本明细表
          break;
        case "EarningCostApprovePane": // 审批tab
          // this.getApproveData();
          break;
        default:
          break;
      }
    },

    /**
     * 获取基础数据
     */
    getBasicData() {
      earningCost({
        id: this.id,
        yearMonth: formatQueryDate(this.yearMonth),
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.basicData = res.data;
          } else {
            this.basicData = {};
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    /**
     * 收入成本确认表的数据
     */
    getQueryEarningCostCheckTable() {
      queryEarningCostCheckTable({
        id: this.id,
        yearMonth: formatQueryDate(this.yearMonth),
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.earningCostCheckTableData = res.data;
          } else {
            this.earningCostCheckTableData = {};
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    /**
     * 收入成本汇总表的数据
     */
    getEarningCostGatherTable() {
      queryEarningCostGatherTable({
        id: this.id,
        yearMonth: formatQueryDate(this.yearMonth),
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.earningCostGatherTableData = res.data;
          } else {
            this.earningCostGatherTableData = {};
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    /**
     * 获取收支明细表数据
     */
    getEarningCostDetailTable() {
      queryEarningCostDetailTable({
        id: this.id,
        yearMonth: formatQueryDate(this.yearMonth),
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.earningCostDetailTableData = res.data;
          } else {
            this.earningCostDetailTableData = {};
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    /**
     * 获取工程成本明细表数据
     */
    getProjectCostDetailTable() {
      queryProjectCostDetailTable({
        id: this.id,
        yearMonth: formatQueryDate(this.yearMonth),
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.projectCostDetailTableData = res.data;
          } else {
            this.projectCostDetailTableData = {};
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    yearMonthChange() {
      switch (this.currentTabName) {
        case "EarningCostBasicTable":
          this.getBasicData(); // 基础表数据
          break;
        case "EarningCostCheckTable": // 收入成本确认表
          this.getQueryEarningCostCheckTable();
          break;
        case "EarningCostGatherTable":
          this.getEarningCostGatherTable(); // 收入成本汇总表
          break;
        case "EarningCostDetailTable":
          this.getEarningCostDetailTable(); // 收支明细表
          break;
        case "ProjectCostDetailTable":
          this.getProjectCostDetailTable(); // 工程成本明细表
          break;
        case "EarningCostApprovePane": // 审批tab
          // this.getApproveData();
          break;
        default:
          break;
      }
    },
    exportData(exportTabs) {
      console.log("exportTabs", exportTabs);
      if (!this.id) {
        this.$alert("操作失败", "提示");
        return;
      }
      earningCostExportapi({
        exportIds: [this.id],
        exportTabs: exportTabs,
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            console.log("=======", res.data);
            let url = res.data;
            const a = document.createElement("a");
            a.href = url;
            a.download = "收入成本";
            a.click();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert("操作失败", "提示");
        });
    },
    closePage() {
      // this.approveFlag 
      // 'currentApprove' 审批项目 'waitApproveDetail' 待审批列表进审批详情 'historyApproveDetail' 审批历史列表进审批详情
      console.log("close page, flag", this.approveFlag)
      if (this.approveFlag) {
        goBackApprove(this.approveFlag, "incomingConstDetail");
      } else {
        this.bus.$emit("tabClose", "incomingConstDetail");
        this.bus.$emit("navMenuChange", {
          routeId: "incomeConstList",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";

.income-cost-detail {
  background: white;
  position: relative;
}

.year-month {
  position: absolute;
  top: 0;
  right: 0;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 16px;
}

/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
/deep/.el-tabs__item:hover {
  color: #069dbc;
}

.approve-handle-wrapper {
  width: 800px;
  min-height: 500px;

  :deep(.el-form-item) {
    display: flex;
  }
  :deep(.el-form-item__content) {
    flex: 1;
  }

  :deep(.el-select) {
    width: 100%;
  }
}
</style>
